import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
import { FaWhatsapp, FaEnvelope } from 'react-icons/fa';
import { COLORS } from '../constants/colors';

function Footer() {
        
    return (
        <footer className='p-3 mt-3 border-top shadow-sm'>
            <Container>
                <Row className='justify-content-center mb-3'>
                    <Col xs={12} sm={6} md={8} lg={10} className='d-flex flex-wrap justify-content-center gap-3'>
                        <Link to='/seller' className="text-dark text-decoration-none px-2">
                            Seller
                        </Link>
                        <Link to='/buyer' className="text-dark text-decoration-none px-2">
                            Buyer
                        </Link>
                        <Link to='/shipping' className="text-dark text-decoration-none px-2">
                            Shipping
                        </Link>
                        <Link to='/terms' className="text-dark text-decoration-none px-2">
                            Terms
                        </Link>
                        <Link to='/privacy' className="text-dark text-decoration-none px-2">
                            Privacy
                        </Link>
                    </Col>
                </Row>

                <Row className='justify-content-center'>
                    <Col xs={12} sm={6} md={4} className='text-center py-3'>
                        <div className='border-bottom pb-2'>
                            <FaWhatsapp className="me-1" style={{ color: COLORS.PLUM }} />
                            <a href="https://wa.me/27829239812" className="text-dark text-decoration-none">WhatsApp Us on +27 82 923 9812</a>&nbsp;&nbsp;|&nbsp;&nbsp;<FaEnvelope className="me-1" style={{ color: COLORS.PLUM }} /><a href="mailto:admin@pigeonauction.co.za" className="text-dark text-decoration-none">admin@pigeonauction.co.za</a>
                        </div>
                        <div className='mt-1'>
                            Copyright &copy; 2025 
                        </div>
                    </Col>
                </Row>
            </Container>
        </footer>
    );
}

export default Footer;
